import { createReducer } from "deox";

import {
  resetPasswordError,
  ResetPasswordErrorPayload,
  resetPasswordInit,
  resetPasswordPending,
  resetPasswordSuccess,
} from "./resetPasswordStateActions";
import { purge } from "../purge/purgeStateActions";

export interface ResetPasswordState {
  status: ResetPasswordStatus;
  payload: ResetPasswordErrorPayload | null;
}
type ResetPasswordStatus = "Initial" | "Pending" | "Success" | "Errored";

export const initialState: ResetPasswordState = {
  status: "Initial",
  payload: null,
};

const resetPasswordReducer = createReducer(initialState, (handleAction) => [
  handleAction(
    resetPasswordSuccess,
    (state, action): ResetPasswordState => ({
      ...state,
      status: "Success",
      payload: null,
    })
  ),
  handleAction(
    resetPasswordPending,
    (state, action): ResetPasswordState => ({
      ...state,
      status: "Pending",
      payload: null,
    })
  ),
  handleAction(
    resetPasswordError,
    (state, action): ResetPasswordState => ({
      ...state,
      status: "Errored",
      payload: action.payload,
    })
  ),
  handleAction(purge, () => initialState),
  handleAction(resetPasswordInit, () => initialState),
]);

export default resetPasswordReducer;
